import request from '../utils/request';
import qs from "qs";

export const getAllTask = param => {
	return request.get('/api/tasks/getAllTask?companyId=' + param.companyId + '&&pageNum=' + param.pageIndex + '&&pageSize=' + param.pageSize, )
};

export const addTask = param => {
	return request.post('/api/tasks/addTask', param, {
		headers: {
			'Content-Type': 'application/json'
		}
	})
};
export const addAssignedAgent = (param, taskId) => {
	return request.post(`/api/tasks/${taskId}/assignedAgent`, param, {
		headers: {
			'Content-Type': 'application/json'
		}
	})
};
export const getmiddlePhone = (param, taskId) => {
	return request.post(`/api/tasks/${taskId}/middlePhone`, param, {
		headers: {
			'Content-Type': 'application/json'
		}
	})
};
export const start = (taskId) => {
	return request.post(`/api/tasks/${taskId}/start`)
};
export const stop = (taskId) => {
	return request.post(`/api/tasks/${taskId}/stop`)
};
export const deleteTask = (taskId) => {
	return request.post(`/api/tasks/${taskId}/delete`)
};
export const getTask = param => {
	return request.get('/api/user-task/get-task?pageIndex=' + param.pageIndex + '&&pageSize=' + param.pageSize + '&&phone=' + param.phone, )
};
export const gettaskid = id => {
	return request.get('/api/user-task/get-task-id?id=' + id, )
};